import {
	Directive,
} from '@angular/core';

import './VbUiBtnDanger.less';

@Directive({
	selector: '[vbUiBtnDanger]',
	host: {
		class: 'vbUiBtnDanger'
	}
})
export class VbUiBtnDangerDirective {}
